/**
 * To try and keep code as similar as possible, the constants should match from the projects:
 * - logic-processor
 * - admin-dashboard
 *
 * The string differences are due to the way we receive the operator values from admin-dashboard.
 */
export default {
  INCLUDES: 'Includes',
  SOME: 'Some',
  EVERY: 'Every',
  IS_LONGER_THAN: 'Is Longer Than',
  IS_EQUAL: 'Equals To (=)',
  IS_NOT_EQUAL: 'Not Equals To',
  EXISTS: 'Exists',
  IS_ONE_OF: 'Is one of',
  IS_VALUE_GREATER: 'Greater Than (>)',
  IS_VALUE_GREATER_THAN_OR_EQUAL_TO: 'Greater Than Or Equal To',
  IS_VALUE_LESS: 'Less Than (<)',
  IS_VALUE_LESS_THAN_OR_EQUAL_TO: 'Less Than Or Equal To',
  IS_TIME_AFTER: 'Time After',
  IS_TIME_AFTER_OR_ON: 'Time After Or On',
  IS_TIME_BEFORE: 'Time Before',
  IS_TIME_BEFORE_OR_ON: 'Time Before Or On',
};
